'use client';

import { useCallback, useEffect, useState } from 'react';

import type { OtroFeoroTO, ResponseInfoFeoroUsuario } from '@/types/goldDate';

interface UseGoldDateListProps {
  dataProps?: ResponseInfoFeoroUsuario;
  isDesktop: boolean;
}

interface GoldDateState {
  presentList: OtroFeoroTO[];
  pastList: OtroFeoroTO[];
  prize: number;
}

export const useGoldDateList = ({
  dataProps,
  isDesktop,
}: UseGoldDateListProps) => {
  const [data, setData] = useState<GoldDateState>();
  const [contentPresentPage, setContentPresentPage] = useState<OtroFeoroTO[]>(
    []
  );
  const [contentPastPage, setContentPastPage] = useState<OtroFeoroTO[]>([]);

  const initPresentList = useCallback(
    (list: OtroFeoroTO[]) => {
      if (isDesktop) {
        setContentPresentPage(list.slice(0, 5));
      } else {
        setContentPresentPage(list || []);
      }
    },
    [isDesktop]
  );

  const initPastList = useCallback(
    (list: OtroFeoroTO[]) => {
      if (isDesktop) {
        setContentPastPage(list.slice(0, 5));
      } else {
        setContentPastPage(list || []);
      }
    },
    [isDesktop]
  );

  const handleContentPresentPage = useCallback((date: OtroFeoroTO[]) => {
    date && setContentPresentPage(date);
  }, []);

  const handleContentLastPage = useCallback((date: OtroFeoroTO[]) => {
    date && setContentPastPage(date);
  }, []);

  useEffect(() => {
    if (dataProps) {
      setData({
        presentList: dataProps.actualesSinPublicar || [],
        pastList: dataProps.todosLosPublicados || [],
        prize: dataProps.premio || 0,
      });

      if (
        dataProps.actualesSinPublicar &&
        dataProps.actualesSinPublicar.length > 0 &&
        !dataProps.estaPublicado
      ) {
        initPresentList(dataProps.actualesSinPublicar);
      }

      if (
        dataProps.todosLosPublicados &&
        dataProps.todosLosPublicados.length > 0
      ) {
        initPastList(dataProps.todosLosPublicados);
      }
    }
  }, [dataProps, initPastList, initPresentList]);

  useEffect(() => {
    return () => {
      setData({ pastList: [], presentList: [], prize: 0 });
      setContentPresentPage([]);
      setContentPastPage([]);
    };
  }, []);

  return {
    data,
    contentPresentPage,
    contentPastPage,
    handleContentPresentPage,
    handleContentLastPage,
  };
};
